module.exports = __webpack_public_path__ + "img/5G_light.cd7d8623.png";